import { ITeamMember, ITeamMemberAvailability } from '../reducers';

export const defaultTeamMemberAvailability: ITeamMemberAvailability = {
  id: '',
  isAvailable: true,
  reasonUnavailabilityType: undefined
};

export const defaultTeamMember: ITeamMember = {
  id: '',
  //@todo handle that the user who create it can select the team
  teamId: '',
  availability: defaultTeamMemberAvailability,
  color: '',
  isChecked: false,
  rights: [],
  user: {
    id: '',
    name: '',
    firstname: '',
    email: '',
    phoneNumber: '',
    imagePath: '',
    userInfos: {
      id: '',
      activityDone: { label: '', value: '' },
      activityTime: { label: '', value: '' }
    }
  }
};
